<template>
  <div class="main-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/about/banner.jpg">
    <div class="text-content">
      <h3>江苏嘉宏投资集团</h3>
      <div class="sub-title">SINCE 1998</div>
      <p>
        江苏嘉宏投资集团始创于1998年，以复合型地产开发为基础，坚持“地产+商业”双轮驱动模式，实现长三角强经济城市的多点扩张，秉持“慧心守护初心，赋写风华人生”的企业愿景，业务涵盖地产、商业、物业、酒店、科技等五大板块的全链条集团产业，并通过风华系的引领，成功进驻无锡、泰州等城市，成为深耕常州，开拓长三角的综合型高端生活服务商。
      </p>
      <p>
        嘉宏集团旗下累积开发30+品质项目，开发面积近1000万㎡，服务业主超10万。集团连续16年获五星企业荣誉,具有一级开发资质,获市重大贡献奖。26载的砥砺前行，嘉宏集团将产品作为与客户的沟通介质，打造出独有的产品品牌，未来嘉宏也将围绕地产主营业务,深度融合酒店文旅、专业市场、空港产业等多元业务领域,积极打造上下游产业联动矩阵,以强化品牌格局,实现人居生活和商业贸易互动叠加,并以奋斗文化砥砺前行,蓄力美好未来。
      </p>
      <div class="seperate-content">
        <div class="seperate-item">
          <span>1000</span>
          <span>万方</span>
          <div>累积开发面积</div>
        </div>
        <div class="seperate-item">
          <span>16</span>
          <span>年</span>
          <div>五星企业荣誉</div>
        </div>
        <div class="seperate-item">
          <span>1</span>
          <span>级</span>
          <div>开发资质</div>
        </div>
        <div class="seperate-item1">
          <span>连续</span>
          <span>5</span>
          <span>年</span>
          <div>获市重大贡献奖</div>
        </div>
      </div>
      <h3 class="text-leader">董事长致辞</h3>
    </div>
    <div class="bottom-about">
        <img class="desc" src="@/assets/about/leader.jpg" alt="">
        <div class="description">
          <div class="description-left">
            <p>集团总部地址：江苏省常州市延陵西路19号嘉宏世纪大厦33楼</p>
            <p>联系电话：4008289980 E-mail: hr@jiahonggroup.com</p>
          </div>
          <div class="qr-code">
            <img src="@/assets/about/qrcode.png">
            <div>扫码关注</div>
          </div>
        </div>
    </div>
  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
export default {
  name: "about",
  components:{
    topNav
  },
  data() {
    return {
      dataList: [],
      orderLog: [],
      form: {
        sn: "",
        statusValue: "",
        deliveryTime: "",
        createTime: "",
        foodWorkName: "",
        shName: "",
        shAddress: ""
      },
      goodsNum: 0,
      totalPrice: 0,
      delivery: [],
      active: 0,
      stepList: [

      ],
      stepIndex:0
    }
  },
  mounted() {
  },
  created() {
    // this.initData()
  },
  methods: {
    exportData(){
      this.downLoadFile(this.search,'请购订单.xlsx')
    },
    downLoadFile(data,fileName){
      let _this = this;
      return request({
        url: '/admin/purchaseRequisitionOrder/exportOrderByInner',
        method: 'post',
        responseType: 'blob',
        data: [_this.form.id],
      }).then((response) => {
        this.handleBlobFile(response, fileName);
      });
    },
    handleBlobFile(response, fileName){
      // 处理返回的文件流
      const blob = response;
      if (blob && blob.size === 0) {
        this.$message.warning("内容为空，下载失败")
        return;
      }
      const link = document.createElement('a');

      // 兼容一下 入参不是 File Blob 类型情况
      var binaryData = [];
      binaryData.push(response);
      link.href = window.URL.createObjectURL(new Blob(binaryData));
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      window.setTimeout(function () {
        // @ts-ignore
        URL.revokeObjectURL(blob);
        document.body.removeChild(link);
      }, 0);
    },

    //点击步骤
    clickStep(e) {
      console.log('所点击步骤信息:', e)
    },
    backOrder(){
      if (Cookies.get("userType")) {
        let userType = Cookies.get("userType")
        if(userType == '4'){
          this.$router.push('/myOrder')
        }
      }
    },
    initData() {
      this.orderLog = [];
      this.form.sn = this.$route.query.sn
      this.getDetail();
    },
    async getDetail() {
      var res = await getCGOrderDetail({sn: this.form.sn})
      if (res.code === 0) {
        this.form = res.data;
        this.dataList = res.data.detailEntities;
        this.orderLog = res.data.orderLogEntities;
        this.goodsNum = res.data.goodsNum;
        this.totalPrice = res.data.totalPrice;
        this.delivery = res.data.distributionOrderEntities
        this.stepList = res.data.orderLogEntities
        console.log(this.delivery)
        // this.stepIndex = this.getStep(this.form.statusValue)
        this.stepIndex = this.stepList.length
      } else {
        this.$message.warning(res.msg)
      }
    },
    getStep(statusValue){
      for (var i = 0;i<this.stepList.length;i++) {
        let item = this.stepList[i]
        if(item.name == statusValue){
          return i
        }
      }
    }
  }
}
</script>

<style>
  @import "../../styles/about.css";
</style>
<style lang="scss" scoped>
.order-top {
  width: 100%;
  /*height: 290px;*/
  background: #FFFFFF;
  box-sizing: border-box;
  padding: 28px 30px 23px;
  .step {
    margin-top: 20px;
    overflow: hidden;
  }
  .order-tit {
    font-size: 24px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #3D3D3D;
    line-height: 30px;
  }
  .order-tf {
    margin-top: 30px;
    width: 100%;
    height: 104px;
    box-sizing: border-box;
    padding-top: 20px;
    background: rgba(244, 244, 244, 0.5);
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    .tf-left, .tf-right {
      div:last-child {
        margin-top: 4px;
      }
    }
    .tf-left {
      margin-left: 67px;
      width: 40%;
    }
  }
}

.order-list {
  margin-top: 10px;
  background-color: #fff;
  box-sizing: border-box;
  padding-left: 23px;
  padding-right: 22px;
  ::v-deep.el-table .cell {
    font-size: 14px !important;
    color: #3D3D3D;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
  }
  ::v-deep.el-table {
    padding-bottom: 10px;
    th {
      height: 50px;
    }
    td {
      border-bottom: 0;
    }
  }

  ::v-deep.el-table__header-wrapper {
    margin-bottom: 10px;
  }
  .img-icon {
    /*margin-top:16px;*/
    width: 70px;
    height: 70px;
  }
  .img-info{
    margin-left: 10px;
    .name-text{
      width: 268px;
      height: 24px;
    }
    .level-info{
      margin-top:22px;
      width: 233px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      box-sizing: border-box;
      padding-left: 10px;
      background: #F4F4F4;
    }
  }
}

/*.list-sum {*/
/*  height: 72px;*/
/*  box-sizing: border-box;*/
/*  padding-top: 17px;*/
/*  color: #3D3D3D;*/
/*  span {*/
/*    display: inline-block;*/
/*  }*/
/*  span:nth-child(2) {*/
/*    margin-left: 15px;*/
/*  }*/
/*  span:nth-child(3) {*/
/*    margin-left: 20px;*/
/*    font-size: 24px;*/
/*    color: #FF8400;*/
/*  }*/
/*  .money {*/
/*    font-size: 24px;*/
/*  }*/
/*}*/

.order-detail {
  margin-top: 10px;
  margin-bottom: 45px;
  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 30px 0;
  .title {
    font-size: 24px;
    margin-bottom: 38px;
  }
  .info-item {
    padding-bottom: 20px;
    border-bottom: 2px solid #F4F4F4;
    .title-text {
      font-size: 16px;
      font-weight: 700;
    }
    .s-info {
      div:first-child {
        width: 45%;
      }
    }
    .sub-text {
      margin-top: 5px;
      font-size: 14px;
    }
  }

  .icon-left {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  .name-text {
    margin-right: 15px;
    font-size: 14px;
    font-family: Source Han Sans-Medium, Source Han Sans;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
  }
  .time-text {
    font-size: 12px;
    font-family: Source Han Sans-Regular, Source Han Sans;
    font-weight: 400;
    color: #999999;
    line-height: 18px;
  }
  .left-line {
    width: 1px;
    height: 134px;
    background: #F2F0F0;
    margin-left: 9px;
    /*margin-right: 13px;*/
  }
  .flow-info {
    margin-top: 20px;
  }
  .img-list {
    margin-left: 6px;
    margin-top: 20px;
    img {
      float: left;
      width: 90px;
      height: 90px;
      border-radius: 2px;
    }
  }
}
.order-log {
  margin-top: 10px;
  margin-bottom: 45px;
  background-color: #FFFF;
  padding: 28px 30px;
  .title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  ::v-deep.el-table td{
    padding: 0!important;
    font-size: 14px;
  }
  ::v-deep.el-table th{
    height: 50px;
    background-color: rgba(244, 244, 244, 0.5);
  }
  ::v-deep.el-table tr{
    height:44px;
  }
}
</style>
